import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const SliderSkeletonLoading = () => <Skeleton height="341px" width="100%" />;

export default SliderSkeletonLoading;
